module.exports = __webpack_public_path__ + "static/media/galerija_2021 (12).50727184.jpg";